import { render, staticRenderFns } from "./OnPlansStats.vue?vue&type=template&id=f6eaacbe&"
import script from "./OnPlansStats.vue?vue&type=script&lang=js&"
export * from "./OnPlansStats.vue?vue&type=script&lang=js&"
import style0 from "./OnPlansStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports